import { lazy, useContext, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { getAllParentModules } from '../../apis/backend/modules';
import AuthContext from '../../contexts/authContext';
import Login from '../../pages/presentation/auth/Login';
import verifyAccess from '../../utils/verifyAccess';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));

const ContentRoutes = () => {
  const { userData } = useContext(AuthContext);
  const [isLoadingFinsh, setLoadingFinsh] = useState(false);
  const [modulesMenu, setModulesMenu] = useState<any[]>([
    {
      id: '404',
      path: '*',
      element: <PAGE_404 />,
      exact: true,
    },
    {
      id: 'login',
      path: 'auth-pages/login',
      element: <Login />,
      exact: true,
    },
  ]);

  useEffect(() => {
    if (userData?.accessToken && userData?.role === 'employe') {
      getAllParentModules(userData?.accessToken, async (modules: any) => {
        const newModulesMenu: any[] = [];

        if (Array.isArray(modules) && modules.length > 0) {
          await Promise.all(
            modules.map(async (module: any) => {
              if (Array.isArray(module?.subModules) && module.subModules.length > 0) {
                module.subModules.forEach((subModule: any) => {
                  const LoadedPageModule = lazy(() =>
                    import(`../../pages/${subModule.route.pageComponentPath}`),
                  );

                  newModulesMenu.push({
                    id: subModule.id,
                    path: subModule.route.path,
                    element: (
                      <LoadedPageModule
                        hasAccess={(access: string) => verifyAccess(subModule?.access, access)}
                      />
                    ),
                    exact: true,
                  });

                  if (Array.isArray(subModule?.othersPagesPath)) {
                    subModule.othersPagesPath.forEach((route: any) => {
                      const LoadedPage = lazy(() =>
                        import(`../../pages/${route.pageComponentPath}`),
                      );
                      newModulesMenu.push({
                        id: route.id,
                        path: route.path,
                        element: (
                          <LoadedPage
                            hasAccess={(access: string) =>
                              verifyAccess(subModule?.access, access)
                            }
                          />
                        ),
                        exact: true,
                      });
                    });
                  }
                });
              }
            }),
          );
        }

        // ✅ Correct update
        setModulesMenu(prev => [...prev, ...newModulesMenu]);
        setLoadingFinsh(true);
      });
    } else if (userData?.accessToken && userData?.role === 'sup_admin') {
      const PagesEnterprises = lazy(() => import('../../pages/presentation/Enterprises'));
      const SingleEnterprise = lazy(
        () => import('../../pages/presentation/Enterprises/SingleEnterprise'),
      );
      const PagesModules = lazy(() => import('../../pages/presentation/Modules'));
      const WELCOMING_PAGE_SUPADMIN = lazy(
        () => import('../../layout/Content/WelcomingPageSupAdmin'),
      );

      setModulesMenu(prev => [
        ...prev,
        {
          id: 'gestionEnterprise',
          path: 'enterprises',
          element: <PagesEnterprises />,
          exact: true,
        },
        {
          id: 'gestionEnterpriseSingle',
          path: 'enterprises/:id',
          element: <SingleEnterprise />,
          exact: true,
        },
        {
          id: 'gestionModules',
          path: 'modules',
          element: <PagesModules />,
          exact: true,
        },
        {
          id: 'gestionModulesSingle',
          path: 'modules/:id',
          element: <PagesModules />,
          exact: true,
        },
        {
          id: 'welcome',
          path: '/',
          element: <WELCOMING_PAGE_SUPADMIN />,
          exact: true,
        },
      ]);
      setLoadingFinsh(true);
    } else if (userData?.accessToken && userData?.role === 'company') {
      const PagesComptes = lazy(() => import('../../pages/presentation/CompanyComptes'));
      const COMPTES_SINGLE = lazy(
        () => import('../../pages/presentation/CompanyComptes/SingleCompte'),
      );
      const COMPTES_SINGLE_ACCESS = lazy(
        () => import('../../pages/presentation/CompanyComptes/SingleCompteAccess'),
      );
      const COMPTE_DETAILS = lazy(() => import('../../pages/Company/CompanyDetails'));
      const WELCOMING_PAGE = lazy(() => import('../../layout/Content/WelcomingPage'));

      setModulesMenu(prev => [
        ...prev,
        {
          id: 'gestionComptes',
          path: 'comptes',
          element: <PagesComptes />,
          exact: true,
        },
        {
          id: 'welcome',
          path: '/',
          element: <WELCOMING_PAGE />,
          exact: true,
        },
        {
          id: 'gestionComptesSingle',
          path: `comptes/:id`,
          element: <COMPTES_SINGLE />,
          exact: true,
        },
        {
          id: 'SingleCompteAccess',
          path: `comptes/:id/access/:id_module`,
          element: <COMPTES_SINGLE_ACCESS />,
          exact: true,
        },
        {
          id: 'SingleCompteDetails',
          path: `company/info`,
          element: <COMPTE_DETAILS />,
          exact: true,
        },
      ]);
      setLoadingFinsh(true);
    } else {
      setLoadingFinsh(true);
    }
  }, [userData?.accessToken, userData?.role]);

  return (
    <Routes>
      {isLoadingFinsh &&
        Array.isArray(modulesMenu) &&
        modulesMenu.map(route => (
          <Route key={route?.id} {...route} />
        ))}
    </Routes>
  );
};

export default ContentRoutes;
